import React, { useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import ConfirmRejectionDialog from 'views/pages/manage/unAssigned/studentFinanceApproval/paymodeApproval/ConfirmRejectionDialog';
import { rejectionHandler } from "../../approvalDashboard/shared/utils";

const BmApprovalAction = ({ data }) => {

    const { updateStatus, userDetails, depositSlipNo, approvalRequests, updateStatusInfo, setUpdateStatusInfo } = data;

    const { id, status, approvalStatus, updatedOn, updatedBy } = approvalRequests;

    return (
        <Card style={{ width: "inherit", height: "auto", width: '400px', marginLeft: "24px" }}>
            <CardBody>
                <div className='d-flex flex-column' style={{ gap: '24px' }}>
                    <div className="dark-text label-color">Request actions</div>
                    <div className="regular-bold color-grey-60">Please take an action for this request. If you want some changes you can always send it back for correction.</div>
                    <div className='d-flex flex-column' style={{ gap: '8px' }}>
                        <AButton
                            variant="danger_filled"
                            size="xs"
                            className="no-ml-btn"
                            onClick={() => rejectionHandler({
                                setUpdateStatusInfo, status, approvalStatus,
                                approvalAction: 'REJECT', isRemarkMandatory: true,
                                updatedOn: updatedOn,
                                updatedBy: updatedBy,
                                isUpdatedDetailRequired: true,
                                depositSlipNo,
                                userDetails,
                                dialogInfo:{
                                remarksMandatory: true
                      }
                            })}
                        >
                            Reject
                        </AButton>

                        <AButton
                            variant="primary_filled"
                            size="xs"
                            className="no-ml-btn"
                            onClick={() => updateStatus({ id, approvalAction: 'APPROVE', ...approvalRequests, userDetails, })}
                        >
                            Approve
                        </AButton>

                        <AButton
                            variant="outline"
                            textColor={"#000"}
                            outlineVariantColor={"#CCC"}
                            className="no-ml-btn"
                            size="xs"
                            onClick={() => {
                                const dialogInfo = {
                                    heading: "Send back for correction",
                                    proceedBtn: <button style={{ backgroundColor: '#00B0F5', width: 'fit-content', color: '#FFF', border: 'none' }}>Send back for correction</button>,
                                    remarksMandatory: true
                                }
                                rejectionHandler({
                                    setUpdateStatusInfo,
                                    status,
                                    approvalStatus,
                                    approvalAction: 'CORRECTION',
                                    dialogInfo,
                                    depositSlipNo,
                                    userDetails,
                                    isRemarkMandatory: true,
                                })
                            }
                            }
                        >
                            Send for Correction
                        </AButton>

                    </div>
                </div>

            </CardBody>
        </Card>
    )
}

export default BmApprovalAction;